import { useState, useEffect } from 'react';
import customHeaders, { getSpace } from '../../../common/headers';
import useGeneralStore from '../../../store/general';
import { ModalComponent } from '../ModalComponent/ModalComponent';
import { HistoryItem } from '../../../pages/CreateCampaignFromRules/Modal/ModalHistoryActions/HistoryItem/HistoryItem';
import { useResponseHandler } from '../../../common/auth';
import './ModalHistoryAccount.scss'

const ModalHistoryAccount = ({ setIsModal, account_id }) => {

    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleTableResponse, handleRequestError } = useResponseHandler();
    const [loading, setLoading] = useState(false)
    const [logsArr, setLogsArr] = useState(null)

    // Получение логов
    const fetchGetLog = () => {
        setLoading(true);
        let url = `https://apps0.ecomru.ru:4242/api/v2/account/history${account_id ? `/${account_id}` : ''}`

        fetch(url, { method: 'GET', headers })
            .then(handleTableResponse)
            .then((json) => setLogsArr(json))
            .catch(handleRequestError)
            .finally(() => setLoading(false));
    }

        useEffect(() => {
            fetchGetLog()
        }, []);

        return (
            <ModalComponent
                title='История изменений'
                onClose={e => setIsModal(false)}
                loading={loading}
                style={{
                    maxWidth: '500px'
                }}
                isNoData={!logsArr?.length}
                child={
                    <div className='modal-history-actions-v2'>
                        {logsArr?.length
                            ?
                            <div className='modal-history-actions-v2__content'>
                                {logsArr?.map((el) => (
                                    <HistoryItem
                                        key={el.comment + el.timestamp}
                                        {...el}
                                    />
                                ))}
                            </div> : null}
                    </div>
                }
            />
        )
    }

    export { ModalHistoryAccount }